import {type ReactNode, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {usePath} from 'hooks';
import {PATHS} from 'routes/constants';
import {PageLayout} from 'components/PageLayout';
import {RegistrationStepSubtitle} from 'components/RegistrationProgress';
import {useIVCaptureKicker} from '../../../ivCaptureCopy';

type Props = {
  children: ReactNode;
  title: ReactNode;
  intro: ReactNode;
  stepLabel?: string;
  onBack?: () => void;
  dock?: ReactNode;
};

export function PageWrapper({children, title, intro, stepLabel, onBack, dock}: Props) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  const handleExit = useCallback(() => {
    navigate(getFullPath(PATHS.guestRegistration), {replace: true});
  }, [navigate, getFullPath]);

  const handleBack = onBack ?? handleExit;

  const kicker = useIVCaptureKicker(t('guest_registration'), stepLabel);

  return (
    <PageLayout
      className="contacts-verification"
      kicker={kicker}
      title={title}
      intro={intro}
      backLabel={onBack ? t('back') : t('summary')}
      onBack={handleBack}
      mobileTitle={t('guest_registration_title')}
      mobileSubtitle={<RegistrationStepSubtitle suffix={stepLabel} />}
      dock={dock}
    >
      <div className="contacts-verification__form flex w-full flex-col gap-4">
        {children}
      </div>
    </PageLayout>
  );
}
